import { render, staticRenderFns } from "./product_hair1.vue?vue&type=template&id=38ef7e96&scoped=true&"
import script from "./product_hair1.vue?vue&type=script&lang=js&"
export * from "./product_hair1.vue?vue&type=script&lang=js&"
import style0 from "./product_hair1.vue?vue&type=style&index=0&id=38ef7e96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef7e96",
  null
  
)

export default component.exports